import { render, staticRenderFns } from "./starshop-action.vue?vue&type=template&id=110c8286"
import script from "./starshop-action.vue?vue&type=script&lang=js"
export * from "./starshop-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports